import React from 'react';

const variants = {
  primary: 'bg-sky-600 text-white hover:bg-sky-700 shadow-sm',
  secondary: 'border border-slate-300 text-slate-700 hover:bg-slate-50',
  ghost: 'text-sky-600 hover:text-sky-700 hover:bg-sky-50',
  danger: 'bg-red-600 text-white hover:bg-red-700',
  white: 'bg-white text-sky-600 hover:bg-sky-50 shadow-sm',
};

const sizes = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-5 py-2.5 text-sm',
  lg: 'px-6 py-3 text-base',
};

export default function Button({ children, variant = 'primary', size = 'md', className = '', disabled, ...props }) {
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 rounded-xl font-medium transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed ${variants[variant]} ${sizes[size]} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
